export default {
    methods: {
        /**
         * Simple URL helpers
         *
         * @param path
         * @returns {`${*}/${string}`}
         */
        restUrl:       (path) => { return `${window.OptimizeFlow.rest_url}${path}` },
        // adminUrl:      (path) => { return `${window.OptimizeMentor.admin_url}${path}` },
        // ajaxUrl:       (path) => { return `${window.OptimizeMentor.ajax_url}/${path}` },
        // webhookApiUrl: (path) => { return `${window.OptimizeMentor.webhook_api_url}/${path}` },
        // builderApiUrl: (path) => { return `${window.OP3WP.apiBaseUrl}/${path}` },
        // assetsUrl:     (path) => { return `${window.OptimizeMentor.assets_url}/${path}` },
        imgUrl:        (path) => { return `${window.OptimizeFlow.img_url}flow/${path}` },

        /**
         * Translate strings
         *
         * @param str
         * @returns {*}
         */
        $e: str => {
            return str
        },

        /**
         * Open up OP3 editor in overlay
         *
         * @returns {boolean}
         */
        openEditor(postId) {
            return !!OP3.Wrapper.Editor.open(postId)
        },

        /**
         * Convert string to slug
         *
         * @param {String} slug
         * @param {Boolean} removeLastDash
         * @return {String}
         */
        slugify(slug, removeLastDash = true) {
            slug = slug
                .toLowerCase()
                .replace(/^-+/g, '')
                .replace(/[^\w-]+/g, '-')
                .replace(/ /g, '-')
                .replace(/-+/g, '-')
                .trim()

            if (removeLastDash) {
                slug = slug.replace(/-$/g, '')
            }

            return slug
        },

        /**
         * Hide/close all modals
         */
        closeAllModals() {
            this.$vfm.hideAll()
        },

        /**
         * Generate random UID
         * @return {String}
         */
        randomUid() {
            return ((+new Date) + Math.random()* 100).toString(32)
            // return Date.now().toString(36) + Math.random().toString(36).substr(2);
        },

        /**
         * Find configuration for a trigger by key
         * @param key
         */
        findTriggerConfig(key) {
            let config = {}
            
            Object.entries(window.OptimizeFlow.config.trigger_groups).forEach(entry => {
                const [groupKey, group] = entry

                Object.entries(group.triggers).forEach(triggerEntry => {
                    const [triggerKey, trigger] = triggerEntry

                    if (key === triggerKey) {
                        config = trigger
                    }
                })
            })

            return config
        },

        /**
         * Find configuration for a filter by key
         * @param key
         */
        findFilterConfig(key) {
            let config = {}

            Object.entries(window.OptimizeFlow.config.filters).forEach(filterEntry => {
                const [filterKey, filter] = filterEntry

                if (key === filterKey) {
                    config = filter
                }
            })

            return config
        },
    },
}
